export default {
  methods: {
    getAvailableMenuItems(menuItems, dataObject = null) {
      return menuItems.filter(item => {
        const isAvailable = typeof item.available === 'function'
          ? item.available(dataObject)
          : item.available !== false;

        if (item.subitems) {
          item.subitems = item.subitems.filter(subitem => {
            return typeof subitem.available === 'function'
              ? subitem.available(dataObject)
              : subitem.available !== false;
          });
          return isAvailable && item.subitems.length > 0;
        }

        return isAvailable;
      });
    },
  },
};
